import React from 'react';

export default props => (
  <div className="card bg-light mb-4">
    <div className="card-body">
      <h3 className="h5 card-title">Print and Include</h3>
      <p className="card-text">
        Please print and include the following documents with your shipment.
      </p>
    </div>
    <ul className="list-group list-group-flush">
      {props.documents.map((doc, index) => (
        <li className="list-group-item" key={`doc-${index}`}>
          <a href={doc.url} target="_blank">
            {doc.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/orders/OrderOutgoingShipmentDocuments.js